<template>
  <div style="overflow-x: hidden;background-color: white;position: absolute;left: 0;right: 0;top: 0" class="bg">
    <Navigator/>
    <SliderBanner  :slider="slider"/>
    <FuncShow :funInfo="funInfo"/>
    <Footer/>
    <ContactFloat/>
  </div>
</template>

<script>
import Navigator from '../widgets/navigator'
import Footer from '../widgets/footer'
import SliderBanner from '../widgets/SliderBanner'
import FuncShow from '../widgets/func-show'
import ContactFloat from '../widgets/contact-float.vue'

export default {
  components: {
    Navigator,
    FuncShow,
    ContactFloat,
    SliderBanner,
    Footer
  },
  data() {
    return {
      slider: {
        image: require('@/assets/images/index/takeaway/phone.png'),
        title: 'CPS出行',
        desc: "为您提供滴滴出行、货运、花小猪等服务"
      },
      funInfo: {
        title: 'CPS出行',
        list: [
          {
            title: '滴滴出行',
            img: require('@/assets/images/index/travel/img1.png'),
            text: '滴滴出行，每日可抢打车优惠券，最高立享8折优惠'
          },
          {
            title: '货运',
            img:  require('@/assets/images/index/travel/img2.png'),
            text: '运货搬家送大件，最高减30元'
          },
          {
            title: '花小猪',
            img: require('@/assets/images/index/travel/img3.png'),
            text: '先领劵，再打车，超省钱，首单立减8元'
          }
        ]
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
